import { isFunction } from 'lodash-es'

/**
 * @link https://github.com/ReactiveX/rxjs/blob/master/src/internal/util/isPromise.ts
 */
// eslint-disable-next-line
export const isPromise = (value: any): value is PromiseLike<any> => {
  return isFunction(value?.then)
}

/**
 * @link https://css-tricks.com/snippets/javascript/random-hex-color
 */
export function generateRandomHex() {
  return Math.floor(Math.random() * 16777215).toString(16)
}

export function generateImage(options: {
  text: string
  textColor?: string
  backgroundColor?: string
  width?: number
  height?: number
  font?: string
}) {
  const {
    text,
    textColor = '#000',
    backgroundColor = '#fff',
    width = 200,
    height = 200,
    font = '14px microsoft yahei'
  } = options
  const canvas = document.createElement('canvas')
  canvas.setAttribute('width', `${width}px`)
  canvas.setAttribute('height', `${height}px`)

  const context = canvas.getContext('2d')
  if (context) {
    context.font = font
    context.textAlign = 'center'
    context.textBaseline = 'middle'

    context.fillStyle = backgroundColor
    context.fillRect(0, 0, canvas.width, canvas.height)

    context.fillStyle = textColor
    context.fillText(text, Math.floor(width / 2), Math.floor(height / 2))
  }

  const base64URL = canvas.toDataURL()

  return base64URL
}

export function isMobile() {
  const flag =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  return flag
}

export function getBoolean(value: unknown) {
  try {
    const boolean = JSON.parse(value as string)
    return boolean
  } catch (e) {
    return false
  }
}

export const idle = function idle(
  cb: (...args: unknown[]) => unknown,
  delay = 0
) {
  if (delay) {
    setTimeout(cb, delay)
    return
  }
  if (window.requestIdleCallback) {
    window.requestIdleCallback(cb)
  } else {
    setTimeout(cb)
  }
}

export const yieldToMain = ({ times = 1 }: { times?: number } = {}) =>
  new Promise(resolve => {
    setTimeout(() => {
      --times
        ? (async () => {
            await yieldToMain({ times })
            resolve(null)
          })()
        : resolve(null)
    }, 0)
  })
